// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2g5mh","header":"ReportDetails_header__1Kb7t","title":"ReportDetails_title__2Yb5Z","left":"ReportDetails_left__2-YlB"};